import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@components';
import { FormActionType, FormType, Translation } from '@enums';
import { useAppDispatch } from '@hooks';
import { updateFormProcedure } from '@store';

interface SettingsActionButtonProps {
  handleSaveModal?: any;
  isLoading?: boolean;
  formType: FormType;
  procedure?: FormActionType;
}

export const SettingsButtons = ({
  handleSaveModal,
  isLoading,
  formType,
  procedure = FormActionType.Save,
}: SettingsActionButtonProps) => {
  const dispatch = useAppDispatch();
  const { t: tConfigurationButton } = useTranslation(Translation.Configuration, { keyPrefix: 'buttons' });

  useEffect(() => {
    dispatch(updateFormProcedure({ formType, procedure }));
  }, [dispatch, formType, procedure]);

  return (
    <div className="flex gap-4 flex-1 items-end sm:flex-none">
      <Button onClick={handleSaveModal} loading={isLoading} className="rounded-lg w-full enabled:shadow-none">
        {tConfigurationButton('saveSettings')}
      </Button>
    </div>
  );
};
